import { IRegisterSchema } from '../@types/register.type';
import { ISignupSchema } from '../@types/signup.type';
import axios from '../utils/axios';

export class AuthService {
  login(email: string, password: string) {
    return axios.post('/auth/login', {
      email,
      password,
    });
  }
  demoRegister(payload: IRegisterSchema) {
    return axios.post('/auth/demo-register', payload);
  }

  signup(payload: ISignupSchema) {
    return axios.post('/auth/signup', payload);
  }

  forgotPassword(email: string) {
    // Sends an email server-side; cap the wait so the button can't spin forever.
    return axios.post<{ message: string }>(
      '/auth/forgot-password',
      { email },
      { timeout: 30_000 },
    );
  }

  resetPassword(payload: { email: string; code: string; password: string }) {
    return axios.post<{ message: string }>('/auth/reset-password', payload);
  }

  getProfile() {
    try {
      return axios.get<any>('/auth/me/profile');
    } catch (error) {
      console.error('An error occurred:', error);
      throw error;
    }
  }
  async getRefreshToken(refreshToken: string) {
    try {
      const response = await axios.post(
        `/auth/refresh`,
        {},
        {
          headers: {
            Authorization: `Bearer ${refreshToken}`,
          },
        },
      );
      return response;
    } catch (error) {
      console.error('An error occurred:', error);
      throw error;
    }
  }
}
